/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { openModalWithBody } from '../../utils/modal-helpers';
window.Invitations = {
  _nameRenderer(doc) {
    if (doc.data.is_expired) { return doc.data.name; }
    return `<a class='document-name' href='${doc.data.project_path}'>${doc.data.name}</a>`;
  },

  _tenderNameRenderer(doc) {
    if (doc.data.is_expired) { return doc.data.tender_name; }
    const path = doc.data.tender_name !== '-' ? doc.data.tender_path : '#';
    return `<a class='tender-name' href='${path}'>${doc.data.tender_name}</a>`;
  },

  _rsvpRenderer(doc) {
    if (doc.data.is_expired) {
      return "<div class='actions'>" +
        "<span class='pt-red' style='font-weight: bold'>" +
        `${I18n.t('v4.invitations.expired')}` +
        "</span>" +
        "</div>";
    } else {
      return "<div class='actions to-middle'>" +
        `<a class='button pt-green nano' href='${doc.data.tender_path}'>` +
        `${I18n.t('v4.invitations.rsvp_invitation')}` +
        "</a>" +
        "</div>";
    }
  },

  _rolesRenderer(doc) {
    if (doc.data.pre_qualified) {
      return `<div>${I18n.t('v4.invitations.prequalify_as')}: <b>${doc.value}</b></div>`;
    } else {
      return `<div>${I18n.t('v4.invitations.participate_as')}: <b>${doc.value}</b></div>`;
    }
  },

  _prepareParticipants(data) {
    data = _.flatten(data.participants);
    return _.filter(data, row => _.keys(row).length > 0);
  },

  initalizeInvitationsTable(tableSelector, data, headers) {
    const columnDefs =
      [
        { headerName: headers['project'], field: 'name', cellRenderer: this._nameRenderer },
        { headerName: headers['tender'], field: 'tender_name', cellRenderer: this._tenderNameRenderer },
        { headerName: headers['issued_by'], field: 'requested_by' },
        { headerName: headers['subject'], field: 'roles', cellRenderer: this._rolesRenderer },
        { headerName: headers['reply'], field: 'reply_by', width: 100 },
        { headerName: headers['rsvp'], headerClass: 'align-right', width: 165, minWidth: 165, suppressSizeToFit: true, cellRenderer: this._rsvpRenderer }
      ];

    const gridOptions = {
      paginationPageSize: 10,
      headerHeight: 44,
      rowHeight: 44,
      columnDefs,
      rowData: this._prepareParticipants(data),
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      onGridReady(e) {
        return e.api.sizeColumnsToFit();
      },
      onGridSizeChanged(event) {
        return event.api.sizeColumnsToFit();
      }
    };

    const gridDiv = document.getElementById(tableSelector);
    const gridApi = agGrid.createGrid(gridDiv, gridOptions);
    gridOptions.api = gridApi;
    resizeAgGridTable(`#${tableSelector}`, gridOptions);

    $(document).on('click', '.accept-invitation', function (e) {
      e.preventDefault();
      const tender = this.dataset.tenderId;
      const company_invitation_ids = this.dataset.companyInvitationIds.split(', ');
      return openModalWithBody(
        'accept-modal',
        '#accept-modal-body',
        `/workplace/projects/${tender}/participants/accept`,
        { company_invitation_ids }
      );
    });

    return $(document).on('click', '.decline-invitation', function (e) {
      e.preventDefault();
      const tender = this.dataset.tenderId;
      const company_invitation_ids = this.dataset.companyInvitationIds.split(', ');
      return openModalWithBody(
        'accept-modal',
        '#accept-modal-body',
        `/workplace/projects/${tender}/participants/decline`,
        { company_invitation_ids }
      );
    });
  },

  _changeRowProps(selector, dropdown_selector, appoint_value, supervisor_value, text) {
    const $row = $(`#${selector}`);
    $row.find(`#${dropdown_selector}`).parent().find('span').text(text);
    $row.find(":checkbox[id$=appoint]").prop('checked', appoint_value);
    $row.find(":checkbox[id$=supervisor]").prop('checked', supervisor_value);
    return this._checkWarningNoteInvents();
  },

  deselectRole(selector, dropdown_selector, text) {
    return this._changeRowProps(selector, dropdown_selector, false, false, text);
  },

  selectRole(selector, dropdown_selector, text) {
    return this._changeRowProps(selector, dropdown_selector, true, false, text);
  },

  selectRoleAsSupervior(selector, dropdown_selector, text) {
    return this._changeRowProps(selector, dropdown_selector, true, true, text);
  },

  _checkWarningNoteInvents() {
    const company_invitation_ids = $('#colleagues_to_appoint').data('companyInvitationIds');
    let count_empty = 0;
    for (let id of Array.from(company_invitation_ids)) {
      const selector = `.${id}-supervisor`;
      if ($(`${selector}:checked`).length === 0) {
        count_empty += 1;
      }
    }
    return $('.at_least_one_supervisor').toggle(count_empty !== 0);
  },

  setupInviteActions() {
    $(document).on('change', '#bid_request input[type=checkbox].confirm', () => $('#bid_request input[type=submit]').toggleClass('disabled'));

    $('.join-tender').find('a#pre-accept').on('click', function (e) {
      e.preventDefault();
      const $form = $(this).closest('form')[0];
      const company_invitation_id = $form.elements["company_invitation_ids[]"].value;
      const tender = $form.elements['tender_id'].value;
      return openModalWithBody(
        'action-modal',
        '#action-modal-body',
        location.pathname + "/participants/pre_accept",
        { company_invitation_ids: [company_invitation_id] }
      );
    });


    $('.join-tender').find('a#accept').on('click', function (e) {
      e.preventDefault();
      const $form = $(this).closest('form')[0];
      const company_invitation_id = $form.elements["company_invitation_ids[]"].value;
      const tender = $form.elements['tender_id'].value;
      return openModalWithBody(
        'action-modal',
        '#action-modal-body',
        location.pathname + "/participants/accept",
        { company_invitation_ids: [company_invitation_id] }
      );
    });


    $('.join-tender').find('a#decline').on('click', function (e) {
      e.preventDefault();
      const $form = $(this).closest('form')[0];
      const company_invitation_id = $form.elements["company_invitation_ids[]"].value;
      const tender = $form.elements['tender_id'].value;
      return openModalWithBody(
        'action-modal',
        '#action-modal-body',
        location.pathname + "/participants/decline",
        { company_invitation_ids: company_invitation_id }
      );
    });

    return $('.join-tender').find('a#upgrade.accept, a#upgrade.decline').on('click', function (e) {
      e.preventDefault();
      return $('#upgrade-modal').foundation('reveal', 'open');
    });
  }
};
